import * as React from "react";
import $ from 'jquery';

interface Props {
  id: string;
  value: number;
  attributeName: string;
  measurementSystem: string;
}

enum Unit {
  mm,
  inches,
  metres
}

interface State {
  micrometres: number;
  unit: Unit;
}

export default class extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      micrometres: props.value,
      unit: this.defaultUnit()
    }
  }

  defaultUnit() {
    switch(this.props.measurementSystem.trim().toLowerCase()) {
      case 'metres':
        return Unit.metres;
      case 'mm_in':
        return (window as any).metric ? Unit.mm : Unit.inches
      case 'metres_in':
        return (window as any).metric ? Unit.metres : Unit.inches
    }
    return Unit.mm;
  }

  updateValue(e: React.ChangeEvent<HTMLInputElement>) {
    const val = e.target.value ? parseFloat(e.target.value) : 0;
    this.setState({micrometres: this.micrometresValue(val)}, () => {
      $(`#${this.props.id}`).val(this.state.micrometres);
    });
  }

  micrometresValue(raw: number) {
    switch (this.state.unit) {
      case Unit.mm:
        return raw * 1000;
      case Unit.inches:
        return raw * 1000 * 25.4;
      case Unit.metres:
        return raw * 1000 * 1000;
      default:
        throw "Unexpected unit";
    }
  }

  updateUnit(e: React.ChangeEvent<HTMLSelectElement>) {
    this.setState({unit: parseInt(e.target.value)})
  }

  displayValue() {
    if (!this.state.micrometres) {
      return "";
    }

    switch (this.state.unit) {
      case Unit.mm:
        return Math.round(this.state.micrometres / 1000 * 10) / 10;
      case Unit.inches:
        return Math.round(this.state.micrometres / 1000 / 25.4 * 100) / 100;
      case Unit.metres:
        return Math.round(this.state.micrometres / 1000 / 1000 * 1000) / 1000;
      default:
        throw "Unexpected unit";
    }
  }

  render() {
    return (<div className="form-group">
      <div className="input-group">
        <input type="number" className="form-control numeric" value={this.displayValue()}
               onChange={(e) => this.updateValue(e)}/>
        <div className="input-group-append">
          <select className="form-control" value={this.state.unit } onChange={(e) => this.updateUnit(e)}>
            <option value={Unit.mm}>mm</option>
            <option value={Unit.inches}>inches</option>
            <option value={Unit.metres}>metres</option>
          </select>
          {/*<span className="input-group-text">mm</span>*/}
        </div>
      </div>
    </div>)
  }

}
